import React from 'react';
import './App.css';
import Rotas from './componentes/Rotas';
import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <div className="App CorFundo">
      <Rotas />
    </div>
  );
}

export default App;
